import _toConsumableArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import Color from '../Color.js';
import { type } from '../utils/index.js';
var pow = Math.pow;
var EPS = 1e-7;
var MAX_ITER = 20;
Color.prototype.luminance = function (lum) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgb';
  if (lum !== undefined && type(lum) === 'number') {
    if (lum === 0) {
      // return pure black
      return new Color([0, 0, 0, this._rgb[3]], 'rgb');
    }
    if (lum === 1) {
      // return pure white
      return new Color([255, 255, 255, this._rgb[3]], 'rgb');
    }
    // compute new color using...
    var cur_lum = this.luminance();
    var max_iter = MAX_ITER;
    var _test = function test(low, high) {
      var mid = low.interpolate(high, 0.5, mode);
      var lm = mid.luminance();
      if (Math.abs(lum - lm) < EPS || !max_iter--) {
        // close enough
        return mid;
      }
      return lm > lum ? _test(low, mid) : _test(mid, high);
    };
    var rgb = (cur_lum > lum ? _test(new Color([0, 0, 0]), this) : _test(this, new Color([255, 255, 255]))).rgb();
    return new Color([].concat(_toConsumableArray(rgb), [this._rgb[3]]));
  }
  return rgb2luminance.apply(void 0, _toConsumableArray(this._rgb.slice(0, 3)));
};
var rgb2luminance = function rgb2luminance(r, g, b) {
  // relative luminance
  // see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
  r = luminance_x(r);
  g = luminance_x(g);
  b = luminance_x(b);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
var luminance_x = function luminance_x(x) {
  x /= 255;
  return x <= 0.03928 ? x / 12.92 : pow((x + 0.055) / 1.055, 2.4);
};